/*
 * @Author: your name
 * @Date: 2021-06-22 13:58:41
 * @LastEditTime: 2021-06-23 09:24:19
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ecfc-oms-facade\src\store\modules\app.js
 */
const state = {
  login: false, // 是否登录
  isCollapse: false, // 菜单折叠标志
  commonMenu: [], // 常用菜单
  permiss: [], // 菜单
  permisIds: [], // 用户拥有的权限id
  userName: "", // 当前登录用户
  orgCode: "", // 当前用户的orgCode
  resMap: [], // 资源所有数据
  resList: [], // 资源所有数据:resKey,realValue,displayValue
  permissUpdateFlag: false, // 退出时是否需要刷新页面
  isTemplateShow: false, // 设置页面是否可见
  theme: "", // 样式
  moduleUrl: "", // 不同文件下不同接口路径
  roleNames: [] ,
}
const mutations = {
  SET_ISCOLLAPSE: (state, data) => {
    let isCollapse = state.isCollapse
    state.isCollapse = !isCollapse
  },
  SET_LOGIN: (state, data) => {
    state.login = data;
  },
  SET_COMMONMENU: (state, data) => {
    state.commonMenu = data;
  },
  SET_PERMISS: (state, data) => {
    state.permiss = data;
    state.permissUpdateFlag = false;
  },
  SET_USERINFO: (state, data) => {
    state.orgId = data.org.orgId;
    state.orgCode = data.org.orgCode;
    state.orgName = data.org.orgName;
    state.userName = data.userName;
    if(data.roleNames){
      state.roleNames = data.roleNames;
    }
  },

  SET_RESMAP: (state, data) => {
    state.resMap = data;
    data.forEach(it => {
      state.resList.push({
        resKey: it.resKey,
        realValue: it.realValue,
        displayValue: it.displayValue
      });
    });
  },

  SET_PERMISS_UPDATE_FLAG: state => {
    state.permissUpdateFlag = true;
  },

  SET_TEMPLATE_SHOW: state => {
    state.templateShow = true;
  },

  SET_THEME: (state, data) => {
    state.theme = data;
  },
  SET_MODULE: (state, data) => {
    state.moduleUrl = data;
  }
}
const actions = {
  setIsCollapse ({commit}) {
    commit('SET_ISCOLLAPSE')
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js